
module.exports = {
  title: '지도통계서비스',
  map: {
    defaultStyle: {
      stroke: true,
      color: 'white',
      weight: 2,
      dashArray: '1',
      opacity: 0,
      fillOpacity: 0,
      fillColor: '#ffffff'
    },
    style: {
      color: '#ffb2a5',
      weight: 1,
      fillColor: '#F0FFF0',
      fillOpacity: 1,
      opacity: 1
    },
    color: {
      defaultRegionalColors: {
        11: '#a65f46', // 서울특별시
        31: '#dac432', // 경기도
        23: '#a1a194', // 인천광역시
        32: '#fb8a8a', // 강원도
        33: '#639688', // 충청북도
        34: '#405952', // 충청남도
        29: '#eed9d9', // 세종시
        25: '#f6a74d', // 대전광역시
        22: '#a8dfff', // 대구광역시
        35: '#a972bb', // 전라북도
        36: '#834996', // 전라남도
        24: '#cbdd78', // 광주광역시
        37: '#5aa6ff', // 경상북도
        38: '#2975ce', // 경상남도
        26: '#e95682', // 울산광역시
        21: '#3e9ec2', // 부산광역시
        39: '#ec6832' // 제주특별자치도
      }
    },
    heatColor: {
      default: ['#f08400', '#ffab0e', '#ffd249', '#ffe79e', '#ffe79e'],
      red: ['#CD1103', '#DD5321', '#E67430', '#F6B64E', '#FFD75D'],
      purple: ['#865DFF', '#AD7BE9', '#E384FF', '#BFDCE5', '#E384FF']
    },
    options: {
      showPopupDataViewType: {
        all: 'all',
        mouseover: 'mouseover'
      }
    }
  }
}
